/**
 * Honeypot field name — must match backend `honeypot` util.
 * Hidden field; legitimate users leave it empty.
 */
export const HONEYPOT_FIELD_NAME = "company_website" as const;

export function isHoneypotTriggered(value: string): boolean {
  return value.trim().length > 0;
}
